'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require('./actionTypes');

var _set = require('lodash/set');

var _set2 = _interopRequireDefault(_set);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {}; // Import Lodash


function moduleData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _actionTypes.UPDATE_MODULE:
            {
                // Create a copy of the state to avoid direct mutation
                var newState = (0, _cloneDeep2.default)(state);
                // Use Lodash's set method to update the state
                (0, _set2.default)(newState, action.payload.key, action.payload.value);
                return newState;
            }
        case _actionTypes.INIT_LAYOUT_JSON:
            // Directly setting layoutJson at the root of the state
            return (0, _extends3.default)({}, state, {
                layoutJson: action.payload // Initialize with payload
            });
        case _actionTypes.UPDATE_LAYOUT_JSON:
            // Directly updating layoutJson at the root of the state
            return (0, _extends3.default)({}, state, {
                layoutJson: action.payload // Replace entire layoutJson
            });
        case _actionTypes.UPDATE_FIELD_VALUE:
            {
                // Deep clone the state to avoid mutation
                var _newState = (0, _cloneDeep2.default)(state);
                // Check if layoutJson exists in the state before trying to set it
                if (!_newState.layoutJson) _newState.layoutJson = {};
                // Use lodash's set function to update the value at the given path within layoutJson
                (0, _set2.default)(_newState.layoutJson, action.payload.statePath, action.payload.value);
                return _newState;
            }
        default:
            return state;
    }
}

exports.default = moduleData;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/module/reducer.js
// module id = 2902
// module chunks = 1137